export type EmbeddingSearchModel = 'google' | 'mploy_v1';

export const EMBEDDING_SEARCH_MODEL_LABELS: Record<EmbeddingSearchModel, string> = {
    google: 'קידוד Google',
    mploy_v1: 'קידוד Mploy V1',
};

export const isEmbeddingSearchModel = (value: unknown): value is EmbeddingSearchModel => (
    value === 'google' || value === 'mploy_v1'
);
